import React from 'react';
import { Button } from '@mui/material';
import { CommonButtonProps } from '../types/common.types';

const CommonButton: React.FC<CommonButtonProps> = ({
  label,
  onClick,
  type = 'button',
  variant = 'contained',
  color = 'primary',
  disabled = false,
  fullWidth = false,
  size = 'medium',
  startIcon,
  endIcon,
}) => {
  return (
    <Button
      type={type}
      variant={variant}
      color={color}
      disabled={disabled}
      fullWidth={fullWidth}
      size={size}
      onClick={onClick}
      startIcon={startIcon}
      endIcon={endIcon}
    >
      {label}
    </Button>
  );
};

export default CommonButton;
